const preloader = document.querySelector('.preloader'),
    errors = document.querySelector('.ajax-errors'),
    errors_modal = errors.closest('.pikulin-modal'),
    messages = document.querySelector('.ajax-messages'),
    messages_modal = messages.closest('.pikulin-modal'),
    payment_form = document.querySelector('form.payment-form');
var payment_secret;

//PIKULIN MODAL
document.onkeydown = (evt) => {
    evt = evt || window.event;
    let isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key === "Escape" || evt.key === "Esc");
    } else {
        isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
        pikulinModalClose();
    }
};
initPikulinModalMove();
function initPikulinModalMove() {
    document.querySelectorAll('.pikulin-modal.move').forEach((modal)=>{
        document.body.appendChild(modal.cloneNode(true));
        modal.remove();
    });
}
initPikulinModalBtns();
function initPikulinModalBtns() {
    document.querySelectorAll('.btn-pikulin-modal:not(.pikulin-modal-inited)').forEach((btn) => {
        btn.classList.add('pikulin-modal-inited');
        btn.addEventListener('click',() => {
            if(btn.hasAttribute('data-change')) {
                const change = JSON.parse(btn.getAttribute('data-change'));
                if(undefined !== change && change.length>0) {
                    change.forEach(data=>{
                        const elements= document.querySelectorAll(data.toggle);
                        if(elements.length>0) {
                            let content = null;
                            if (undefined !== data.contentToggle) {
                                const get_element = document.querySelector(data.contentToggle);
                                if (get_element !== null) {
                                    if(get_element.tagName==='INPUT') {
                                        content = (get_element.hasAttribute('data-url') ? get_element.getAttribute('data-url') : '')+get_element.value;
                                    } else {
                                        content = undefined === data.getAttribute ? get_element.innerHTML : get_element.getAttribute(data.getAttribute);
                                    }
                                }
                            } else if (undefined !== data.content) {
                                content = data.content;
                            }
                            if (undefined === data.setAttribute) {
                                elements.forEach(element => {
                                    element.innerHTML = content;
                                });
                            } else {
                                if(data.setAttribute==="selected") {
                                    let t = elements[0].parentElement.querySelector('option[selected]');
                                    if(t!==null) {
                                        t.removeAttribute('selected');
                                    }
                                }
                                elements.forEach(element => {
                                    element.setAttribute(data.setAttribute, content);
                                });
                            }
                        }
                    });
                }
            }
            pikulinModalShow(document.querySelector(btn.getAttribute('data-toggle')));
        });
    });
    document.querySelectorAll('.btn-pikulin-modal-close:not(.pikulin-modal-inited)').forEach((btn) => {
        btn.classList.add('pikulin-modal-inited');
        btn.addEventListener('click',pikulinModalClose);
    });
}
let observerForPikulinModalBtns = new MutationObserver(initPikulinModalBtns);
observerForPikulinModalBtns.observe(document.body, {
    childList: true,
    subtree: true,
});

function bodyOnClickPikulinModelClose(e) {
    if(
        document.body.classList.contains('pikulin-modal-show') &&
        e.target.closest('.pikulin-modal-content') === null &&
        closest(e.target,'pikulin-modal-content') === false &&
        e.target.closest('.btn-pikulin-modal') === null &&
        e.target.closest('.btn-pikulin-modal-close') === null
    ) {
        let r = document.querySelector('.pikulin-modal.show .pikulin-modal-content').getBoundingClientRect();
        if(
            e.clientX<r.x ||
            e.clientX>r.x+r.width ||
            e.clientY<r.y ||
            e.clientY>r.y+r.height
        ) {
            e.preventDefault();
            pikulinModalClose();
        }
    }
}
function closest(el,className) {
    if(el.classList.contains(className)) {
        return true
    } else if(el.parentElement===null) {
        return el.tagName!=='HTML';
    } else if(el.parentElement.classList.contains(className)) {
        return true;
    } else {
        return closest(el.parentElement,className);
    }
}

function pikulinModalShow(modal) {
    const openedModal = document.querySelector('.pikulin-modal.show');
    if(openedModal === null) {
        modal.classList.add('show');
        document.body.style.maxWidth = document.body.offsetWidth + 'px';
        document.body.classList.add('pikulin-modal-show');
        if(!modal.classList.contains('pikulin-modal-no-close')) {
            setTimeout(() => {
                document.body.addEventListener('mousedown', bodyOnClickPikulinModelClose);
            }, 300);
        }
    } else {
        openedModal.classList.remove('show');
        modal.classList.add('show');
    }
    pikulinTrigger(modal,'showed');
}

function pikulinModalClose() {
    const modal = document.querySelector('.pikulin-modal.show');
    if(modal!==null) {
        modal.classList.remove('show');
        pikulinTrigger(modal,'closed');
    }
    document.body.classList.remove('pikulin-modal-show');
    document.body.removeEventListener('mousedown',bodyOnClickPikulinModelClose);
}
//EXIT PIKULIN MODAL

//PIKULIN TRIGGER
function pikulinTrigger(element,event) {
    if ("createEvent" in document) {
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, false, true);
        element.dispatchEvent(evt);
    }
    else
        element.fireEvent("on"+event);
}

//COOKIE
function setCookie(name, value, options) {
    options = options || {};

    var expires = options.expires;
    if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 60 * 60 * 1000);
        expires = options.expires = d;
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }
    }
    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }
    if(options.SameSite===undefined) {
        if(document.location.protocol==='https:') {
            updatedCookie += '; SameSite=None; Secure';
        } else {
            updatedCookie += '; SameSite=Lax';
        }
    }

    document.cookie = updatedCookie;
}

// Get cookie by name
function getCookie(name) {
    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

// Delete cookie by name
function deleteCookie(name,options) {
    options.expires = -1;
    setCookie(name, "", options)
}
//EXIT COOKIE

document.querySelectorAll('form').forEach(form=>{
    const is_payment_form = form.classList.contains('payment-form');
    form.addEventListener('submit', evt => {
        evt.preventDefault();
        if(is_payment_form && form.classList.contains('multi')) {
            pikulinModalShow(document.getElementById('modal-payment-system'));
        } else {
            preloader.classList.add('show');
            let form_data = new FormData(form);
            form_data.append('fp', fp.getId());
            if(form.hasAttribute('data-parent-form')) {
                for (let pair of (new FormData(document.querySelector(form.getAttribute('data-parent-form')))).entries()) {
                    form_data.append(pair[0], pair[1]);
                }
            }
            fetch(window.location.pathname,
                {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: form_data
                })
                .then(response => {
                    if (response.status !== 200) {
                        return Promise.reject();
                    }
                    return response.json();
                })
                .then(data => {
                    if ('undefined' !== typeof data.errors) {
                        let errors_html = '<ul>';
                        data.errors.forEach(error => {
                            errors_html += '<li>' + error + '</li>';
                        });
                        errors.innerHTML = errors_html + '</ul>';
                        if (errors_modal !== null) {
                            pikulinModalShow(errors_modal);
                        }
                        preloader.classList.remove('show');
                    } else if ('undefined' !== typeof data.messages) {
                        let messages_html = '<ul>';
                        data.messages.forEach(error => {
                            messages_html += '<li>' + error + '</li>';
                        });
                        messages.innerHTML = messages_html + '</ul>';
                        if (messages_modal !== null) {
                            pikulinModalShow(messages_modal);
                        }
                        preloader.classList.remove('show');
                    } else if (
                        // is_payment_form &&
                        'undefined' !== typeof data.result
                    ) {
                        if('undefined'===typeof data.data.redirect) {
                            window[data.data.payment_system + 'CreatePaymentForm'](data.data);
                        } else {
                            //let iframe = document.createElement('iframe');
                            //iframe.setAttribute('src',data.data.redirect);
                            //document.body.appendChild(iframe);
                            window.location.href = data.data.redirect;
                            preloader.classList.remove('show');
                        }
                    } else if ('undefined' !== typeof data.go) {
                        let btn = document.createElement('a');
                        btn.setAttribute('href', data.go);
                        btn.click();
                        preloader.classList.remove('show');
                    } else if ('undefined' === typeof data.result) {
                        alert('Critical error. Please try again. This page reload');
                        window.location.reload(true);
                    }
                })
                .catch(e => {
                    console.error(e);
                    alert('Critical error. Please try again. This page reload');
                    window.location.reload(true);
                });
        }
    });
});

window.addEventListener('load',() => {
    document.querySelectorAll('.link-description').forEach(wrapper=>{
        if(wrapper.querySelector('span').offsetHeight>130) {
            wrapper.addEventListener('click',evt=>{
                evt.preventDefault();
                if(wrapper.classList.contains('show')) {
                    wrapper.classList.remove('show');
                } else {
                    wrapper.classList.add('show');
                }
            });
        } else {
            wrapper.classList.add('hide-spoiler');
        }
        wrapper.classList.add('init');
    });
});

function initTotalOld() {
    const total = document.querySelector('.total');
    if(total!==null) {
        const currency = total.getAttribute('data-currency'),
            fee = parseFloat(total.getAttribute('data-fee'))/100,
            field_price = document.querySelector('[name="price"]'),
            field_fee = document.querySelector('[name="fee"]'),
            payment_systems_el = document.querySelectorAll('[name="payment_system"]'),
            total_price = document.querySelectorAll('.total-price');
        let payment_systems = [],
            payment_systems_isset = false;
        if(payment_systems_el.length>0) {
            payment_systems_isset = true;
            payment_systems_el.forEach((el)=>{
                payment_systems.push({
                    'el': el,
                    'fee': parseFloat(el.getAttribute('data-fee'))/100,
                    'currency': el.getAttribute('data-currency'),
                    'exchange_rate': parseFloat(el.getAttribute('data-exchange-rate')),
                    'min_amount': parseInt(el.getAttribute('data-min-amount'))/100,
                    'price': parseInt(el.getAttribute('data-price'))/100,
                });
            });
        }
        if (field_price === null) {
            const field_event = document.querySelector('[name="event"]');
            if(field_event===null) {
                if (field_fee !== null) {
                    const price = parseFloat(total.getAttribute('data-price'));
                    if(payment_systems_isset) {
                        field_fee.addEventListener('change', () => {
                            payment_systems.forEach((payment_system)=>{
                                let r = '';
                                if(field_fee.checked) {
                                    r = payment_system.price * payment_system.fee;
                                    if(r<0.01) {
                                        r = 0.01;
                                    }

                                    r = payment_system.currency + ' ' +
                                        (
                                            payment_system.price + r
                                        ).toFixed(2);
                                } else {
                                    r = payment_system.currency + ' ' +
                                        payment_system.price.toFixed(2);
                                }
                                payment_system.el.setAttribute('data-cost',r);
                                if(payment_system.el.checked) {
                                    total_price.forEach((el)=>{
                                        el.innerHTML = r;
                                    });
                                }
                            });
                        });
                    } else {
                        field_fee.addEventListener('change', () => {
                            if(field_fee.checked) {
                                let r = Math.ceil(price * 100 * (fee / 100)) / 100;
                                if(r<0.01) {
                                    r = 0.01;
                                }
                                total.innerHTML = currency + ' ' + (price + r).toFixed(2);
                            } else {
                                total.innerHTML = currency + ' ' + price.toFixed(2);
                            }
                        });
                    }
                }
            } else {
                field_event.addEventListener('change',calc);
                if (field_fee !== null) {
                    field_fee.addEventListener('change', calc);
                }
                function calc() {
                    const cost = field_event.closest('.for-custom-select').querySelector('[data-value="'+field_event.value+'"] .cost').innerHTML
                    if(field_fee.checked) {
                        let price = parseFloat(cost.trim().substr(cost.indexOf(' ')+1));
                        total.innerHTML = currency + ' ' + (price + Math.ceil(price*100 * (fee / 100))/100).toFixed(2);
                    } else {
                        total.innerHTML = cost;
                    }
                }
            }
        }
        else {
            field_price.addEventListener('keyup', calc);
            field_price.addEventListener('change', calc);
            if (field_fee !== null) {
                field_fee.addEventListener('change', calc);
            }
            function calc() {
                const v = parseFloat(field_price.value);
                let r = '';
                if(isNaN(v) || v === 0) {
                    total.innerHTML = r;
                    if(payment_systems_isset) {
                        payment_systems.forEach((payment_system) => {
                            payment_system.el.setAttribute('data-cost', r);
                            if (payment_system.el.checked) {
                                total_price.forEach((el) => {
                                    el.innerHTML = r;
                                });
                            }
                        });
                    }
                }
                else {
                    if(field_fee !== null && field_fee.checked && !payment_systems_isset) {
                        if(v*fee<0.01) {
                            r = v + 0.01;
                        } else {
                            r = v + v * fee;
                        }
                    } else {
                        r = v;
                    }
                    total.innerHTML = currency + ' ' + r;
                    if(payment_systems_isset) {
                        payment_systems.forEach((payment_system)=>{
                            r = '';
                            if(!isNaN(v) && v > 0) {
                                r = v*payment_system.exchange_rate;
                                if(r<payment_system.min_amount) {
                                    r = payment_system.min_amount;
                                }
                                if(field_fee !== null && field_fee.checked) {
                                    if(r * payment_system.fee<0.01) {
                                        r = r + 0.01;
                                    } else {
                                        r = r + r * payment_system.fee;
                                    }
                                }
                                r = payment_system.currency + ' ' + r.toFixed(2);
                            }
                            payment_system.el.setAttribute('data-cost',r);
                            if(payment_system.el.checked) {
                                total_price.forEach((el)=>{
                                    el.innerHTML = r;
                                });
                            }
                        });
                    }
                }
            }
        }
    }
}
function initTotal() {
    const el_total = document.querySelector('.total');
    if(el_total!==null) {
        const format = el_total.getAttribute('data-format'),
            fee = parseFloat(el_total.getAttribute('data-fee')),
            min_fee = parseFloat(el_total.getAttribute('data-min-fee')),
            el_field_price = document.querySelector('[name="price"]'),
            min_amount = el_field_price===null ? 0 : parseFloat(el_field_price.getAttribute('min')),
            el_field_fee = document.querySelector('[name="fee"]'),
            el_total_price = document.querySelectorAll('.total-price'),
            el_total_price_isset = el_total_price.length>0,
            el_payment_systems = document.querySelectorAll('[name="payment_system"]');

        let payment_systems = [],
            el_payment_systems_isset = el_payment_systems.length>0;
        if(el_payment_systems_isset) {
            el_payment_systems.forEach((el)=>{
                payment_systems.push({
                    'el': el,
                    'fee': parseFloat(el.getAttribute('data-fee')),
                    'min_fee': parseFloat(el.getAttribute('data-min-fee')),
                    'currency': el.getAttribute('data-currency'),
                    'format': el.getAttribute('data-format'),
                    'exchange_rate': parseFloat(el.getAttribute('data-exchange-rate')),
                    'min_amount': parseInt(el.getAttribute('data-min-amount'))/100,
                    'price': parseInt(el.getAttribute('data-price'))/100,
                });
            });
        }

        if(el_field_price === null) {
            const field_event = document.querySelector('[name="event"]');
            if(field_event===null) {
                if (el_field_fee !== null) {
                    const price = parseFloat(el_total.getAttribute('data-price'));
                    el_field_fee.addEventListener('change', () => {
                        calc(price);
                    });
                    calc(price);
                }
            }
            else {
                let price = 0;//parseFloat(field_event.closest('.for-custom-select').querySelector('[data-value="'+field_event.value+'"]').getAttribute('data-price'));
                field_event.addEventListener('change',()=>{
                    price = parseFloat(field_event.closest('.for-custom-select').querySelector('[data-value="'+field_event.value+'"]').getAttribute('data-price'));
                    calc(price);
                });
                if (el_field_fee !== null) {
                    el_field_fee.addEventListener('change', () => {
                        calc(price);
                    });
                }
                calc(price);
            }
        }
        else {
            el_field_price.addEventListener('keyup', ()=>{
                calc(el_field_price.value);
            });
            el_field_price.addEventListener('change', ()=>{
                calc(el_field_price.value);
            });
            if (el_field_fee !== null) {
                el_field_fee.addEventListener('change', ()=> {
                    calc(el_field_price.value);
                });
            }
            if(el_payment_systems_isset) {
                el_payment_systems.forEach((el) => {
                    el.addEventListener('change',()=>{
                        calc(el_field_price.value);
                    });
                });
            }
            calc(el_field_price.value);
        }

        function calc(amount) {
            let v = parseFloat(amount),
                r = '';
            if (!isNaN(v) && v > 0) {
                let current_data = {
                    'fee': fee,
                    'min_fee' : min_fee,
                    'min_amount': min_amount,
                    'exchange_rate': 1,
                    'format': format
                };
                if(el_payment_systems_isset) {
                    payment_systems.forEach(payment_system=>{
                        if(payment_system.el.checked) {
                            current_data = payment_system;
                        }
                    });
                }
                v = v * current_data.exchange_rate;
                if(v<current_data.min_amount) {
                    v = current_data.min_amount;
                }
                if (current_data.fee > 0 && (el_field_fee === null || el_field_fee.checked)) {
                    r = v / (100 - current_data.fee) * current_data.fee;
                    r = r < current_data.min_fee ? v + current_data.min_fee : r + v;
                    r = current_data.format.replace('%a', (r.toFixed(2)).toString());
                } else {
                    r = current_data.format.replace('%a', (v.toFixed(2)).toString());
                }
            }
            el_total.innerHTML = r;
            if (el_total_price_isset) {
                el_total_price.forEach(el=>{
                    el.innerHTML = r;
                });
            }
        }
    }
}
initTotal();

function initPaymentSystemSelect() {
    const payment_systems = document.querySelectorAll('[name="payment_system"]');
    if(payment_systems.length>1) {
        payment_systems.forEach((payment_system)=>{
            if(payment_system.checked) {
                pikulinTrigger(payment_system,'change');
            }
        });
    }
}
initPaymentSystemSelect();